'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Chip = require('../../Chip');

var _Chip2 = _interopRequireDefault(_Chip);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function SelectedFieldsToAssign(_ref) {
  var values = _ref.values,
      _onDelete = _ref.onDelete;
  return values.map(function (value, index) {
    var key = 'field-' + index;
    return _react2["default"].createElement(_Chip2["default"], {
      key: key,
      className: 'rainbow-import-records-flow_step-three-chip-field',
      label: value,
      title: value,
      variant: 'neutral',
      onDelete: function onDelete() {
        return _onDelete(value);
      }
    });
  });
}

exports["default"] = SelectedFieldsToAssign;
SelectedFieldsToAssign.propTypes = {
  values: _propTypes2["default"].array,
  onDelete: _propTypes2["default"].func
};
SelectedFieldsToAssign.defaultProps = {
  values: [],
  onDelete: function onDelete() {}
};